import { render, staticRenderFns } from "./mobidtySchool.vue?vue&type=template&id=1c0572f8&scoped=true&"
import script from "./mobidtySchool.vue?vue&type=script&lang=js&"
export * from "./mobidtySchool.vue?vue&type=script&lang=js&"
import style0 from "./mobidtySchool.vue?vue&type=style&index=0&id=1c0572f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0572f8",
  null
  
)

export default component.exports